<script lang="ts" setup>
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

const props = defineProps<Omit<FontAwesomeIconProps, 'icon' | 'spin'>>();
</script>

<template>
  <FontAwesomeIcon
    v-bind="props"
    class="[--fa-animation-duration:.5s]"
    :icon="faSpinnerThird"
    spin
  />
</template>
